module.exports = __webpack_public_path__ + "img/curtain-close.ff16ee37.svg";